<script setup>

const props = defineProps({
    total: {
        type: Number,
        required: true
    },
    current: {
        type: Number, 
        required: true
    },
    arrow_type: { 
        type: String,
        required: false,
        default: 'WhiteBackArrow'
    }
})

const emit = defineEmits(['forward', 'back'])

const goesBack = computed(() => {
    return props.current > 0
})

const goesForward = computed(() => {
    return props.current < props.total - 1
})

</script>

<template>
    <div class='back-next'>
        <button @click="emit('back')" aria-label="Go to previous story" class='previous' :class="{ active: goesBack }" :disabled="!goesBack">
            <MessSvg :type="arrow_type" />
        </button>
        <button @click="emit('forward')" aria-label="Go to next story" class='next' :class="{ active: goesForward }" :disabled="!goesForward">
            <MessSvg :type="arrow_type" />
        </button>
    </div>
</template>

<style lang="scss">
    .back-next {
        display: flex;
        align-items: center;
        gap: 20px;

        button {
            opacity: 0.5;
            transition: 250ms ease;
            &.active {
                opacity: 1;
            }
        }

        .previous svg {
            rotate: -180deg;
        }
    }
</style>